import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@utils/api';
import classNames from 'classnames';
import cookie from 'react-cookies';
import { appPostStructuredMessage } from '@common/utils/appUtils';
import { is } from '@common/utils/brandDiffsUtils';
import analytics from '@utils/analytics';
import stoneAnalytics from '@stone/utils/analytics';
const AppleSigninButton = (props) => {
    const { t } = useTranslation();
    const [appleConfInit, setAppleConfInit] = useState(null);
    useEffect(() => {
        try {
            api.getAppleSigninConfiguration().then((data) => {
                var _a, _b;
                if ((_a = data === null || data === void 0 ? void 0 : data.configuration) === null || _a === void 0 ? void 0 : _a.enabled) {
                    const _appleConfInit = {
                        clientId: data.configuration.clientId,
                        redirectURI: data.configuration.redirectURI,
                        scope: 'email name',
                        nonce: '',
                        state: data.configuration.state,
                        usePopup: true,
                    };
                    setAppleConfInit(_appleConfInit);
                    (_b = window.AppleID) === null || _b === void 0 ? void 0 : _b.auth.init(_appleConfInit);
                }
                props.setIsLoading && props.setIsLoading(false);
            });
        }
        catch (e) {
            console.log('Apple Signin Error: ' + e);
            props.setIsLoading && props.setIsLoading(false);
        }
    }, []);
    const signInSuccess = () => {
        document.addEventListener('AppleIDSignInOnSuccess', (event) => {
            // Handle successful response.
            let authorizationResponse = {
                authorization: {
                    code: event.detail.authorization.code,
                    id_token: event.detail.authorization.id_token,
                    state: event.detail.authorization.state,
                },
                user: {
                    email: event.detail.user && event.detail.user.email ? event.detail.user.email : '',
                    name: {
                        firstName: event.detail.user && event.detail.user.name ? event.detail.user.name.firstName : '',
                        lastName: event.detail.user && event.detail.user.name ? event.detail.user.name.lastName : '',
                    },
                },
            };
            if (authorizationResponse.authorization.state !== appleConfInit.state) {
                console.log('During AppleIDSignInOnSuccess authorization.state was corrupted');
                return React.createElement(React.Fragment, null);
            }
            props.setIsLoading && props.setIsLoading(true);
            // props.register currently means we are in the register page, so it does not reload the page, it just valorize data.values, if we want a consinstent behavior we should redirect also here (or handle all async)
            api.appleSignInSuccess(authorizationResponse.authorization.id_token, authorizationResponse.user, props.register).then((data) => {
                if (data.success) {
                    if (data.login) {
                        // login successful executed, reload page
                        is('MO') && analytics.socialLoginGeneric({ event: 'my moncler', eventCategory: 'my moncler', eventAction: 'apple-login', eventLabel: 'login' }); // send analytics if effective social login
                        // Sent to BE information to redirect the user to the wishlist if he comes from it
                        if (props.from === 'wishlist') {
                            cookie.save('fromWishlist', 'true', { path: '/', maxAge: 600 });
                        }
                        else {
                            cookie.remove('fromWishlist');
                        }
                        window.location.reload();
                    }
                    else if (data.register) {
                        // redirect from login page to register page with prefilled form information
                        window.location.replace(window.registerUrl);
                    }
                }
            });
        });
    };
    const signInFailure = () => {
        // Listen for authorization failures.
        document.addEventListener('AppleIDSignInOnFailure', (event) => {
            let error = event.detail.error;
            console.error(error);
            return;
        });
    };
    const appleSignin = () => {
        if (is('MO')) {
            props.from && analytics.expressCheckoutSocialLoginRegister(props.from, 'apple');
            props.analyticsKey === 'earlyAccess' && analytics[props.analyticsKey]('pop-up', 'apple-login');
        }
        window.AppleID.auth.signIn(appleConfInit);
        signInSuccess();
        signInFailure();
    };
    return (React.createElement("button", { "aria-label": props.register ? t('signup.apple') : t('signin.apple'), type: "button", onClick: () => {
            // send analytics social btn clicked
            if (is('MO')) {
                props.from === 'wishlist'
                    ? analytics.socialLoginGeneric({ event: 'popup', eventCategory: 'popup', eventAction: 'apple-login', eventLabel: 'open' })
                    : analytics.socialLoginGeneric({ eventAction: 'apple-login' });
            }
            else {
                stoneAnalytics.loginOrRegister('apple');
            }
            if (!window.appmode) {
                appleSignin();
            }
            else {
                appPostStructuredMessage('apple_signin', {});
            }
            // props.setIsLoading(false);
        }, className: classNames('button social-button', `button--${props.secondary ? 'secondary' : 'link'}`) },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "icon--social-apple" }),
            props.register ? t('signup.apple') : t('signin.apple'))));
};
export default AppleSigninButton;
